










import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'

@Component({
    name: 'ldw-clock'
})

export default class ClockComponent extends Vue {
    // data
    private hour: number = 0
    private minute: number = 0
    private isOpen: boolean = false

    // methods
    private mounted() {
        setInterval(() => {
            const date: Date = new Date()
            this.hour = ( ((date.getHours() + 11) % 12 + 1) * 30 ) + 0.5 * date.getMinutes()
            this.minute = date.getMinutes() * 6
            const timeOpening: Date = new Date()
            const timeClosing: Date = new Date()

            timeOpening.setHours(8)
            timeOpening.setMinutes(0)

            timeClosing.setHours(18)
            timeClosing.setMinutes(0)

            this.isOpen = date <= timeClosing && date >= timeOpening

        }, 1000)
    }
}
